<template>
  <div v-if="application.customers.length">

    <div v-for="(customer, index) in application.customers" :key="index"
         class="mb-4">
      <h4 class="tab__content__title">{{ $lang.app.CUSTOMER_INFORMATION }}</h4>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.CUSTOMER_OWNER }}</span>
        <span class="stack__value">{{ customer.isOwner ? $lang.app.YES : $lang.app.NO }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.MAIN_CUSTOMER }}</span>
        <span class="stack__value">{{ customer.main ? $lang.app.YES : $lang.app.NO }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.TYPE }}</span>
        <span class="stack__value">{{ $lang.app[userTypesGetLabelRefByValue(customer.type)] }}</span>
      </div>



      <template v-if="(customer.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')
          || customer.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')) && customer.person">

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PIN }}</span>
          <span class="stack__value">{{ customer.person.pin }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.SURNAME }}</span>
          <span class="stack__value">{{ customer.person.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NAME }}</span>
          <span class="stack__value">{{ customer.person.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
          <span class="stack__value">{{ customer.person.patronymic }}</span>
        </div>

      </template>

      <template v-if="customer.type === userTypesGetValueByKey('LEGAL_ENTITY') && customer.organization">

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.INN }}</span>
          <span class="stack__value">{{ customer.organization.inn }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.MAIN_CUSTOMER }}</span>
          <span class="stack__value">{{ customer.main ? $lang.app.YES : $lang.app.NO }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_NAME_RU }}</span>
          <span class="stack__value">{{ customer.organization.nameRu }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_SURNAME }}</span>
          <span class="stack__value">{{ customer.organization.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_NAME }}</span>
          <span class="stack__value">{{ customer.organization.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_PATRONYMIC }}</span>
          <span class="stack__value">{{ customer.organization.patronymic }}</span>
        </div>

      </template>

      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PHONE }}</span>
        <span class="stack__value">{{ customer.contactDetail?.phone }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.WORK_PHONE }}</span>
        <span class="stack__value">{{ customer.contactDetail?.phoneWork }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.EMAIL }}</span>
        <span class="stack__value">{{ customer.contactDetail?.email }}</span>
      </div>

    </div>

  </div>
</template>
<script>
import {
  getValueByKey as userTypesGetValueByKey,
  getLabelRefByValue as userTypesGetLabelRefByValue,
} from "../../../helpers/constants/userTypes";

export default {
  props: {
    application: Object
  },
  methods: {
    userTypesGetValueByKey,
    userTypesGetLabelRefByValue,
  }
}
</script>